import { REPORT } from '@consts/reports';
import { BaseReport } from '../BaseReport';
import { useReportLoad } from '@hooks/useReportLoad';
import { average, countUnique, sum } from '@utils/summaries';
import { basicSort } from '@utils/sort';
import { useRange } from '@hooks/useRange';
import { styleDateRange } from '@utils/styles';

interface MaterialTypeCutsByResellerProps {
    dateRange: { startDate: string; endDate: string };
}

export const MaterialTypeCutsByReseller = ({ dateRange }: MaterialTypeCutsByResellerProps) => {
    const [range, setRange] = useRange('MaterialTypeCutsByReseller');

    const { data, hasData, loading } = useReportLoad({
        reportType: REPORT.RESELLER_MATERIAL_TYPE_CUTS_BY_RESELLER,
        params: { ...dateRange, range },
    });

    return (
        <BaseReport
            title={'Material Type Cuts by Reseller'}
            description={
                'This table shows you the % breakdown of each material type by Reseller for the time period selected in the date range above.'
            }
            rangeText={styleDateRange([dateRange.startDate, dateRange.endDate])}
            loading={loading}
            hasData={hasData}
            setRange={setRange}
            range={range}
            tableOptions={{
                headers: ['Reseller Name', 'Total Cuts', 'Original %', 'Matte %', 'Fusion %', 'Style Skins %', 'Pruvia %'],
                data: data.map((item) => [
                    item.resellerName,
                    item.totalCuts,
                    item.originalPct,
                    item.mattePct,
                    item.fusionPct,
                    item.styleSkinPct,
                    item.pruviaPct,
                ]),
                summaries: [countUnique, sum, average, average, average, average, average],
                sort: [basicSort, basicSort, basicSort, basicSort, basicSort, basicSort, basicSort],
            }}
        />
    );
};
